import React, { useState, useEffect, useCallback, useRef } from 'react';
import { GoPlusCircle } from 'react-icons/go';
import Transactionstable from './Transactionstable';
import WalletTopup from './WalletTopup';
import { useParams } from 'react-router-dom';
import { getWalletBalance } from '../services/Wallet/balance';

const InfoRow = ({ label, value }) => {
  return (
    <div className="mb-2 md:mb-4">
      <p className="text-sm md:text-base">{label}</p>
      <p className="font-semibold text-lg md:text-[20px]">₹{value?.toFixed(2)}</p>
    </div>
  );
};

const SubAnchorBalanceInfo = ({ walletId, dsaId }) => {
  const [activeTab, setActiveTab] = useState('transactions');
  const [walletAmount, setWalletAmount] = useState(null);
  const [minimumAmount, setMinimumAmount] = useState(null);
  const { id } = useParams();
  const fetchInFlightRef = useRef(null);

  const fetchBalance = useCallback(async () => {
    try {
      const data = await getWalletBalance(walletId);
      setWalletAmount(data.amount);
      setMinimumAmount(data.minimum_amount);
    } catch (error) {
      console.error("Failed to fetch wallet info:", error);
    }
  }, [walletId]);

  useEffect(() => {
    if (!id || !walletId) return;
    const requestKey = `subanchor-balance-${walletId}`;
    if (fetchInFlightRef.current === requestKey) return;
    fetchInFlightRef.current = requestKey;
    fetchBalance().finally(() => {
      fetchInFlightRef.current = null;
    });
  }, [id, walletId, fetchBalance]);

  const renderActiveComponent = () => {
    switch (activeTab) {
      case 'walletTopup':
        return <WalletTopup onTopupSuccess={fetchBalance} walletId={walletId} anchorType={'sub_anchor'} dsaId={dsaId} className="my-4" />;
      case 'transactions':
      default:
        return <Transactionstable walletId={walletId} className="my-4" />;
    }
  };

  return (
    <div className="bg-[#F3F4F6] rounded-md mx-4 my-4 p-4 flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:justify-between gap-4">
        <div className="flex flex-col md:flex-row gap-4">
          <InfoRow label="Wallet Balance" value={walletAmount ?? 0} />
          <InfoRow label="Minimum Balance" value={minimumAmount ?? 0} />
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            className={`flex items-center gap-2 px-4 py-2 rounded font-medium
              ${activeTab === 'walletTopup'
                ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                : "bg-[#F0F6FE] text-[#233B85]"}`}
            onClick={() => setActiveTab('walletTopup')}
          >
            <GoPlusCircle color="#233B85" /> Wallet Top-up
          </button>
          <button
            className={`px-4 py-2 rounded font-medium 
    ${activeTab === 'transactions'
                ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                : "bg-[#F0F6FE] text-[#233B85]"}`}
            onClick={() => setActiveTab('transactions')}
          >
            Transactions
          </button>

        </div>
      </div>

      <div>{renderActiveComponent()}</div>
    </div>
  );
};

export default SubAnchorBalanceInfo;
